package team.platforma.multiplatform_material_extension.ui.drop_down

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.rememberScrollState
import androidx.compose.material3.DropdownMenuItem
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.ExposedDropdownMenuBox
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.MenuAnchorType
import androidx.compose.material3.OutlinedTextField
import androidx.compose.material3.Text
import androidx.compose.material3.TextField
import androidx.compose.material3.TextFieldColors
import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.focus.FocusRequester
import androidx.compose.ui.focus.focusRequester
import androidx.compose.ui.focus.onFocusChanged
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.input.key.Key
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import materialextension.multiplatform_material_extension.generated.resources.Res
import materialextension.multiplatform_material_extension.generated.resources.ic24_mel_arrow_down
import materialextension.multiplatform_material_extension.generated.resources.mel_ic_clear
import materialextension.multiplatform_material_extension.generated.resources.mel_ic_down
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.painterResource
import team.platforma.multiplatform_material_extension.ui.core.InputField
import team.platforma.multiplatform_material_extension.ui.core.InputFieldProperties
import team.platforma.multiplatform_material_extension.ui.core.InputFieldStateListener
import team.platforma.multiplatform_material_extension.ui.core.StyledTextField
import team.platforma.multiplatform_material_extension.ui.core.field_utils.endIcon
import team.platforma.multiplatform_material_extension.ui.core.global_style.area.supportArea
import team.platforma.multiplatform_material_extension.ui.core.global_style.setFiledTextFieldDefaults
import team.platforma.multiplatform_material_extension.ui.core.global_style.setOutlinedTextFieldDefaults
import team.platforma.multiplatform_material_extension.ui.core.global_style.shape.setFilledTextFieldDefaultShape
import team.platforma.multiplatform_material_extension.ui.core.global_style.shape.setOutlineTextFieldDefaultShape
import team.platforma.multiplatform_material_extension.ui.core.rememberInputFieldState
import team.platforma.multiplatform_material_extension.ui.drop_down.DropDownFieldStyle.mDropDownListOutlinedStyle
import team.platforma.multiplatform_material_extension.ui.drop_down.DropDownFieldStyle.mDropDownListStyle
import team.platforma.multiplatform_material_extension.ui.drop_down.model.ListItem
import team.platforma.multiplatform_material_extension.util.forms.FormProperties
import team.platforma.multiplatform_material_extension.util.forms.keyListener
import team.platforma.multiplatform_material_extension.util.forms.rememberForms
import team.platforma.multiplatform_material_extension.util.verticalScrollbar
@Deprecated("")
object DropdownField : InputField {
    @Composable
    fun create(
        modifier: Modifier? = null,
        list: List<ListItem>,
        onItemSet: (item: ListItem) -> Unit,
        initializeItem: ListItem? = null,
        formProperties: FormProperties? = null,
        required: Boolean = true,
        onClear: () -> Unit = {}
    ): StyledTextField {

        val mForm by rememberForms()

        val form = formProperties ?: FormProperties(mForm, key = "")

        LaunchedEffect(form.key) {
            form.form.initValue(form.key, initializeItem.toString())
            form.form.changeValue(form.key, initializeItem.toString())
        }


        return builder(
            DropdownImpl(
                itemsList = list,
                onItemSet = {
                    onItemSet(it)
                },
                initializeItem = initializeItem,
                form = form,
                required = required,
                clear = { onClear() },
                areaModifier = modifier
            )
        )
    }

    override fun builder(textFieldImpl: StyledTextField): StyledTextField = textFieldImpl
}

@OptIn(ExperimentalMaterial3Api::class)
@Composable
private fun DropdownImpl(
    areaModifier: Modifier?,
    itemsList: List<ListItem>,
    onItemSet: (item: ListItem) -> Unit,
    initializeItem: ListItem?,
    form: FormProperties,
    required: Boolean,
    clear: () -> Unit
): StyledTextField {


    val inputFieldState = rememberInputFieldState()

    val focusRequester = remember { FocusRequester() }
    val index = remember { form.form.registerFocus(focusRequester) }

    var expanded by remember { mutableStateOf(false) }
    var mayByExpanded by remember { mutableStateOf(true) }
    var selectedItem by remember { mutableStateOf<ListItem?>(null) }



    LaunchedEffect(initializeItem) {
        if (required) {
            selectedItem = initializeItem
            form.form.changeValue(form.key, selectedItem.toString())
            form.form.setValidateState(form.key, selectedItem != null)

        } else {
            selectedItem = initializeItem

            if (selectedItem != null) {
                mayByExpanded = false
            }
            form.form.changeValue(form.key, selectedItem.toString())
            form.form.setValidateState(form.key, true)
        }
    }



    DisposableEffect(inputFieldState) {
        val listener = object : InputFieldStateListener {

            override fun onEndIconClick() {
                if (!mayByExpanded) {
                    selectedItem = null
                    mayByExpanded = true
                    clear()
                    form.form.changeValue(form.key, selectedItem.toString())
                    form.form.setValidateState(form.key, true)
                }
            }

            override fun onAutocompleteItemSet(item: ListItem) {
                selectedItem = item
                onItemSet(item)
                if (!required) {
                    mayByExpanded = false
                }
                form.form.changeValue(form.key, selectedItem.toString())
                form.form.setValidateState(form.key, true)
            }
        }

        inputFieldState.addListener(listener)

        onDispose {
            inputFieldState.removeListener(listener)
        }
    }


    return object : StyledTextField {

        @Composable
        override fun Outline(properties: InputFieldProperties?) {

            Box(
                modifier = (areaModifier ?: Modifier).then(
                    Modifier.padding(bottom = supportArea().value.dp)
                )
            ) {
                val scrollState = rememberScrollState()

                ExposedDropdownMenuBox(
                    modifier = Modifier,
                    expanded = expanded,
                    onExpandedChange = {
                        expanded = !expanded && mayByExpanded
                    }) {
                    Column {
                        OutlinedTextField(
                            value = selectedItem?.title ?: "",
                            onValueChange = {},
                            trailingIcon = {
                                endIcon(
                                    if (mayByExpanded) mDropDownListOutlinedStyle.dropDownListStyle.endIcon
                                        ?: Res.drawable.ic24_mel_arrow_down else Res.drawable.mel_ic_clear,
                                    inputFieldState,
                                    rotate = expanded
                                )

                            },
                            label = properties?.label,
                            modifier = (properties?.modifier
                                ?: Modifier).menuAnchor(MenuAnchorType.PrimaryEditable, true)
                                .onFocusChanged { focusState ->
                                    expanded = focusState.isFocused
                                }.keyListener(Key.Tab) {
                                    form.form.moveToNextFocus(index)
                                }.focusRequester(focusRequester),
                            readOnly = true,
                            colors = properties?.colors ?: setOutlinedTextFieldDefaults(),
                            shape = properties?.shape ?: setOutlineTextFieldDefaultShape(),
                        )
                    }

                    ExposedDropdownMenu(
                        modifier = Modifier.verticalScrollbar(scrollState)
                            .background(color = mDropDownListOutlinedStyle.dropDownListStyle.dropDownListBackgroundColor),
                        expanded = expanded,
                        onDismissRequest = { expanded = false },
                        scrollState = scrollState,

                        ) {

                        itemsList.forEachIndexed { index, item ->
                            val isItemSelected = item == selectedItem
                            val modifier = if (isItemSelected) {
                                println("Selected background")
                                Modifier.padding(mDropDownListOutlinedStyle.dropDownItemStyle.verticalPadding)
                                    .background(color = mDropDownListOutlinedStyle.dropDownItemStyle.selectedItemBackgroundColor)
                            } else {
                                println("Not Selected background")
                                Modifier.padding(mDropDownListOutlinedStyle.dropDownItemStyle.verticalPadding)
                                    .background(color = mDropDownListOutlinedStyle.dropDownItemStyle.itemBackgroundColor)
                            }
                            DropdownMenuItem(modifier = modifier, text = {
                                Column {
                                    Text(
                                        text = item.title, style = if (isItemSelected) {
                                            println("Selected text")
                                            mDropDownListOutlinedStyle.dropDownItemStyle.selectedTextStyle.copy(
                                                color = mDropDownListOutlinedStyle.dropDownItemStyle.selectedItemTextColor
                                            )
                                        } else {
                                            println("Not Selected text")
                                            mDropDownListOutlinedStyle.dropDownItemStyle.textItemStyle.copy(
                                                color = mDropDownListOutlinedStyle.dropDownItemStyle.itemTextColor
                                            )
                                        }
                                    )
                                }

                            }, trailingIcon = {
                                if (isItemSelected) {
                                    println("Creating end icon")
                                    mDropDownListOutlinedStyle.dropDownItemStyle.selectedItemEndIcon?.let { iconRes ->
                                        println("With icon:$iconRes")
                                        Icon(
                                            painter = painterResource(iconRes),
                                            contentDescription = "",
                                            tint = mDropDownListOutlinedStyle.dropDownItemStyle.selectedItemEndIconTint
                                                ?: mDropDownListOutlinedStyle.dropDownItemStyle.selectedItemTextColor
                                        )
                                    }
                                }
                            }, onClick = {
                                inputFieldState.setAutocompleteItem(item)
                                expanded = false
                            })
                            if (index < itemsList.lastIndex) {
                                HorizontalDivider(
                                    modifier = Modifier.padding(horizontal = 16.dp),
                                    color = MaterialTheme.colorScheme.onSurface.copy(alpha = 0.12f)
                                )
                            }
                        }

                    }

                }
            }
        }

        @Composable
        override fun Filled(properties: InputFieldProperties?) {
            Box(
                modifier = (areaModifier ?: Modifier)
                    .then(
                        Modifier.padding(bottom = supportArea().value.dp)
                    )
            ) {
                val scrollState = rememberScrollState()

                ExposedDropdownMenuBox(
                    modifier = Modifier,
                    expanded = expanded,
                    onExpandedChange = {
                        expanded = !expanded && mayByExpanded
                    }) {
                    Column {
                        TextField(
                            value = selectedItem?.title ?: "",
                            onValueChange = {},
                            trailingIcon = {
                                endIcon(
                                    if (mayByExpanded) DropDownFieldStyle.mDropDownListStyle.dropDownListStyle.endIcon
                                        ?: Res.drawable.ic24_mel_arrow_down else Res.drawable.mel_ic_clear,
                                    inputFieldState,
                                    rotate = expanded,
                                    tint = DropDownFieldStyle.mDropDownListStyle.dropDownListStyle.iconTint
                                )

                            },
                            label = properties?.label,
                            modifier = (properties?.modifier
                                ?: Modifier).menuAnchor(MenuAnchorType.PrimaryEditable, true)
                                .onFocusChanged { focusState ->
                                    expanded = focusState.isFocused
                                }.keyListener(Key.Tab) {
                                    form.form.moveToNextFocus(index)
                                }.focusRequester(focusRequester),
                            readOnly = true,
                            colors = properties?.colors
                                ?: DropDownFieldStyle.mDropDownListStyle.dropDownListStyle.textFieldColors
                                ?: setFiledTextFieldDefaults(),
                            shape = properties?.shape ?: setFilledTextFieldDefaultShape(),
                        )
                    }


                    ExposedDropdownMenu(
                        modifier = Modifier.verticalScrollbar(scrollState)
                            .background(color = mDropDownListStyle.dropDownListStyle.dropDownListBackgroundColor),
                        expanded = expanded,
                        onDismissRequest = { expanded = false },
                        scrollState = scrollState,

                        ) {

                        itemsList.forEachIndexed { index, item ->
                            val isItemSelected = item == selectedItem
                            val modifier = if (isItemSelected) {
                                println("Selected background")
                                Modifier.padding(mDropDownListStyle.dropDownItemStyle.verticalPadding)
                                    .background(color = mDropDownListStyle.dropDownItemStyle.selectedItemBackgroundColor)
                            } else {
                                println("Not Selected background")
                                Modifier.padding(mDropDownListStyle.dropDownItemStyle.verticalPadding)
                                    .background(color = mDropDownListStyle.dropDownItemStyle.itemBackgroundColor)
                            }
                            DropdownMenuItem(modifier = modifier, text = {
                                Column {
                                    Text(
                                        text = item.title,
                                        style = if (isItemSelected) {
                                            println("Selected text")
                                            mDropDownListStyle.dropDownItemStyle.selectedTextStyle.copy(
                                                color = mDropDownListStyle.dropDownItemStyle.selectedItemTextColor
                                            )
                                        } else {
                                            println("Not Selected text")
                                            mDropDownListStyle.dropDownItemStyle.textItemStyle.copy(
                                                color = mDropDownListStyle.dropDownItemStyle.itemTextColor
                                            )
                                        }
                                    )
                                }
                            },
                                trailingIcon = {
                                    if (isItemSelected) {
                                        println("Creating end icon")
                                        mDropDownListStyle.dropDownItemStyle.selectedItemEndIcon?.let { iconRes ->
                                            println("With icon:$iconRes")
                                            Icon(
                                                painter = painterResource(iconRes),
                                                contentDescription = "",
                                                tint = mDropDownListStyle.dropDownItemStyle.selectedItemEndIconTint
                                                    ?: mDropDownListStyle.dropDownItemStyle.selectedItemTextColor
                                            )
                                        }
                                    }
                                }, onClick = {
                                    inputFieldState.setAutocompleteItem(item)
                                    expanded = false
                                })
                            if (index < itemsList.lastIndex) {
                                HorizontalDivider(
                                    modifier = Modifier.padding(horizontal = 16.dp),
                                    color = MaterialTheme.colorScheme.onSurface.copy(alpha = 0.12f)
                                )
                            }
                        }
                    }
                }
            }
        }
    }
}

object DropDownFieldStyle {
    internal var mDropDownListStyle: DropDownListStyle = DropDownListStyle(
        DropDownItemStyle(
            itemBackgroundColor = Color.Transparent,
            selectedItemBackgroundColor = Color.Transparent,
            itemTextColor = Color.Transparent,
            selectedItemTextColor = Color.Transparent,
            selectedItemEndIcon = null,
            selectedItemEndIconTint = null,
            textItemStyle = TextStyle(),
            selectedTextStyle = TextStyle()
        ),
        DropDownTextFieldStyle(
            endIcon = null,
            iconTint = null,
            textFieldColors = null,
            dropDownListBackgroundColor = Color.White
        )
    )

    internal var mDropDownListOutlinedStyle: DropDownListStyle = DropDownListStyle(
        DropDownItemStyle(
            itemBackgroundColor = Color.Transparent,
            selectedItemBackgroundColor = Color.Transparent,
            itemTextColor = Color.Transparent,
            selectedItemTextColor = Color.Transparent,
            selectedItemEndIcon = null,
            selectedItemEndIconTint = null,
            textItemStyle = TextStyle(),
            selectedTextStyle = TextStyle()
        ),
        DropDownTextFieldStyle(
            endIcon = null,
            iconTint = null,
            textFieldColors = null,
            dropDownListBackgroundColor = Color.White
        )
    )

    fun define(style: DropDownListStyle, outlinedStyle: DropDownListStyle) {
        mDropDownListStyle = style
        mDropDownListOutlinedStyle = outlinedStyle
    }
}

data class DropDownListStyle(
    val dropDownItemStyle: DropDownItemStyle, val dropDownListStyle: DropDownTextFieldStyle
)

data class DropDownItemStyle(
    val itemBackgroundColor: Color,
    val selectedItemBackgroundColor: Color,
    val itemTextColor: Color,
    val selectedItemTextColor: Color,
    val selectedItemEndIcon: DrawableResource?,
    val selectedItemEndIconTint: Color?,
    val textItemStyle: TextStyle,
    val selectedTextStyle: TextStyle,
    val verticalPadding: Dp = 0.dp
)

data class DropDownTextFieldStyle(
    val endIcon: DrawableResource?,
    val iconTint: Color?,
    val textFieldColors: TextFieldColors?,
    val dropDownListBackgroundColor: Color
)